// extracted by css-extract-rspack-plugin
export default {"select":"J3AjzC20CGoIxcGm","value":"koTOhWvhYAjhckTv"};